<ion-card *ngIf="!!installer" mode="ios">
  <ion-card-header>
    <gc-user-header [user]="installer" [workOrder]="workOrder.currentDetailedWorkOrder$ | push"></gc-user-header>
  </ion-card-header>

  <ion-card-content class="ion-text-center">
    <ion-row>
      <ion-col size="12" size-md="9">
        <p class="text-left">
          <ion-text *ngIf="!!$any(realInstaller).bio" color="dark">
            {{ $any(realInstaller).bio }}
          </ion-text>
        </p>
      </ion-col>
      <ion-col size="12" size-md="3" class="flex-center-end">
        <!-- Declined this work order: surface the decline and do NOT offer to
             award it to them. -->
        <ion-chip
          *ngIf="installer.matchedResponse === 'DECLINED'"
          color="danger"
          outline="true"
          class="ion-margin status-chip"
          data-cy="installer-declined-chip"
        >
          <ion-icon name="close-circle"></ion-icon>
          <ion-label>Declined</ion-label>
        </ion-chip>
        <ng-container *ngIf="installer.matchedResponse !== 'DECLINED'">
          <!-- Surface the response type as a status pill (mirrors the Declined
               chip above) so the company can see at a glance who accepted vs is
               negotiating, alongside the review action. -->
          <ion-chip
            *ngIf="installer.matchedResponse === 'ACCEPTED'"
            color="success"
            outline="true"
            class="ion-margin status-chip"
            data-cy="installer-accepted-chip"
          >
            <ion-icon name="checkmark-circle"></ion-icon>
            <ion-label>Accepted</ion-label>
          </ion-chip>
          <ion-chip
            *ngIf="installer.matchedResponse === 'NEGOTIATING'"
            color="warning"
            outline="true"
            class="ion-margin status-chip"
            data-cy="installer-negotiating-chip"
          >
            <ion-icon name="swap-horizontal"></ion-icon>
            <ion-label>Negotiating</ion-label>
          </ion-chip>
          <ion-button
            *ngIf="installer.negotiation || installer.negotiationItems?.length"
            color="danger"
            class="ion-margin"
            (click)="viewed.emit(installer)"
          >
            Review Negotiation
          </ion-button>
          <ion-button
            *ngIf="!(installer.negotiation || installer.negotiationItems?.length)"
            color="dark"
            class="ion-margin"
            (click)="viewed.emit(installer)"
          >
            Review Award Options
          </ion-button>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-card-content>
</ion-card>
